export class Action {
    id?: number;
    automationActionId?: number;
    name: string;
    command: string;
    description: string;
    parameters: string;
    builtIn: number;
}